import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useApiClient } from "../useApiClient";
import type { components } from "../schema";

import { TAGS_QUERY_KEY } from "./useTags";

type CreateTagBody = components["schemas"]["CreateTagBody"];
type TagResponse = components["schemas"]["TagResponse"];

export function useCreateTag() {
  const client = useApiClient();
  const queryClient = useQueryClient();
  return useMutation<TagResponse, Error, CreateTagBody>({
    mutationFn: async (body) => {
      const { data, error } = await client.POST("/api/tags", { body });
      if (error !== undefined) {
        throw new Error("Failed to create tag");
      }
      return data;
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: TAGS_QUERY_KEY });
    },
  });
}
